import Component, {
  isSellerReputationBannerVisible,
} from '../../../../../pages/vip/features/seller-reputation-banner/seller-reputation-banner';

export default Component;
export { isSellerReputationBannerVisible };
